import { Block } from '@attom';
import { useTimer } from '@hooks';

import CS from './CircleClock.module.scss';

export const CircleClock = ({
	// box Control
	boxClass = '',
	boxSize = '',
	boxSpace = '',
	//
	localTime = '',
	localName = '',
	circleClockStyle = '',
	localNameStyle = '',
	digitClockStyle = '',
	showSeconds = true,
	showMinute = true,
	showHours = true,
}) => {
	const currentTime = new Date(new Date().toDateString() + ' ' + localTime).getTime();

	const { time } = useTimer(currentTime, true);

	const seconds = new Date(time).getSeconds();
	const minute = new Date(time).getMinutes();
	const hours = new Date(time).getHours();

	const secondsDeg = seconds * 6;
	const minuteDeg = minute * 6;
	const hoursDeg = hours * 30 + minute / 2;

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace}>
			<div className={`${CS.container}`}>
				{/* Circle Clock */}
				<div className={`${CS.circleClock} ${circleClockStyle && circleClockStyle}`}>
					{/* Center Point */}
					<span className={CS.centerPoint}></span>
					{/* Hourse Arrow */}
					{showHours && (
						<span
							className={CS.hourseArrow}
							style={{ transform: `translate(-50%, -50%) rotate(${hoursDeg}deg)` }}
						></span>
					)}
					{/* Minute Arrow */}
					{showMinute && (
						<span
							className={CS.minuteArrow}
							style={{ transform: `translate(-50%, -50%) rotate(${minuteDeg}deg)` }}
						></span>
					)}
					{/* Seconds Arrow */}
					{showSeconds && (
						<span
							className={CS.secondsArrow}
							style={{ transform: `translate(-50%, -50%) rotate(${secondsDeg}deg)` }}
						></span>
					)}
					{/* Clock Point */}
					<div className={CS.clockPointBox}>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
						<span className={CS.clockPoint}></span>
					</div>
				</div>
				{/* Local Name */}
				<span className={`${CS.localName} ${localNameStyle && localNameStyle}`}>{localName}</span>
				{/* Digit Clock */}
				<span className={`${CS.digitClock} ${digitClockStyle && digitClockStyle}`}>
					{hours < 10 ? `0${hours}` : hours}:{minute < 10 ? `0${minute}` : minute}:
					{seconds < 10 ? `0${seconds}` : seconds}
				</span>
			</div>
		</Block>
	);
};
